// 공유 전달 확인용 1회성 토큰.
//
// Web Share API 는 공유 시트에서 대상이 선택됐는지(resolve/AbortError)까지만
// 알려주고, 실제로 상대에게 전달됐는지는 알려주지 않는다. 카카오톡만
// serverCallbackArgs 웹훅으로 성공을 확정할 수 있다.
//
// 그래서 공유 URL 에 짧은 토큰(?s=)을 심고, 그 링크로 들어온 유입에서 같은
// 토큰을 기록한다. 두 토큰이 매칭되면 "공유가 실제로 전달되어 열렸다"가 확정된다.
// 수신자가 링크를 눌러야만 잡히므로 실제 전달 건수의 하한값이다.

export const SHARE_TOKEN_PARAM = "s";

const TOKEN_ALPHABET = "abcdefghijklmnopqrstuvwxyz0123456789";
const BASE_LENGTH = 8;
// 토큰 = 마운트별 base + 공유 수단 1글자. 같은 화면에서 여러 수단을 눌러도
// 어느 수단으로 나간 링크가 열렸는지 구분된다.
const METHOD_CODES: Record<string, string> = {
  kakao: "k",
  facebook: "f",
  x: "x",
  line: "l",
  telegram: "t",
  instagram: "i",
  native: "n",
  copy_link: "c",
};

const TOKEN_PATTERN = /^[a-z0-9]{4,24}$/;

function randomBytes(length: number): Uint8Array {
  const bytes = new Uint8Array(length);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
    return bytes;
  }
  for (let i = 0; i < length; i += 1) {
    bytes[i] = Math.floor(Math.random() * 256);
  }
  return bytes;
}

export function createShareTokenBase(): string {
  const bytes = randomBytes(BASE_LENGTH);
  let out = "";
  for (const byte of bytes) {
    out += TOKEN_ALPHABET[byte % TOKEN_ALPHABET.length];
  }
  return out;
}

export function shareTokenFor(base: string, method: string): string {
  return `${base}${METHOD_CODES[method] ?? "o"}`;
}

// URL 에 토큰을 붙인다. 이미 s= 가 있으면 덮어쓴다.
export function withShareToken(url: string, token: string): string {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set(SHARE_TOKEN_PARAM, token);
    return parsed.toString();
  } catch {
    // 상대 경로 등 파싱 불가 URL 은 원본 유지 (계측보다 공유 동작이 우선).
    return url;
  }
}

export function isValidShareToken(value: unknown): value is string {
  return typeof value === "string" && TOKEN_PATTERN.test(value);
}

export function normalizeShareToken(value: unknown): string | undefined {
  return isValidShareToken(value) ? value : undefined;
}
